/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solution Dilution Calculator`)
};

const es_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Dilución de Soluciones`)
};

const de_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdünnungsrechner für Lösungen`)
};

const nl_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdunningscalculator voor oplossingen`)
};

const fr_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de dilution de solution`)
};

const it_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di diluizione di soluzioni`)
};

const pt_br2_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diluição de Soluções`)
};

const pt_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Diluição de Soluções`)
};

const ja_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶液希釈計算ツール`)
};

const zh_soldil_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶液稀释计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_tool_name", locale)
	if (locale === "en") return en_soldil_tool_name(inputs)
	if (locale === "es") return es_soldil_tool_name(inputs)
	if (locale === "de") return de_soldil_tool_name(inputs)
	if (locale === "nl") return nl_soldil_tool_name(inputs)
	if (locale === "fr") return fr_soldil_tool_name(inputs)
	if (locale === "it") return it_soldil_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_tool_name(inputs)
	if (locale === "pt") return pt_soldil_tool_name(inputs)
	if (locale === "ja") return ja_soldil_tool_name(inputs)
	return zh_soldil_tool_name(inputs)
};